import apiHandler from "../core/apiHandler";

const reportApi = apiHandler('reports');
export default reportApi;
